import { useState } from "react";
import { Globe } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { LANGUAGES, getLang, setLang } from "@/lib/i18n";

export function LanguageSelect({ onChange, className, testId = "language-select" }) {
  const [value, setValue] = useState(getLang());
  const change = async (v) => {
    setValue(v);
    if (onChange) await onChange(v);
    setLang(v);
  };
  return (
    <Select value={value} onValueChange={change}>
      <SelectTrigger className={className || "w-40"} data-testid={testId}>
        <Globe className="mr-1.5 h-4 w-4 text-muted-foreground" /><SelectValue />
      </SelectTrigger>
      <SelectContent>
        {LANGUAGES.map(([c, l]) => <SelectItem key={c} value={c} data-testid={`language-option-${c}`}><span translate="no">{l}</span></SelectItem>)}
      </SelectContent>
    </Select>
  );
}
